import builderIoService from "~/composables/builderIoService";
import { useLocaleStore } from "~/stores/localeStore";
import { URL_CONFIG } from "~~/shared/utils/url.const.js";
import { CONTENT_TYPES } from "~~/shared/utils/contentTypes";

export const useNewsRoomDetail = () => {
  const service = builderIoService();
  const route = useRoute();
  const localeStore = useLocaleStore();

  const slug = computed(() => {
    const slugParam = route.params.slug;
    if (Array.isArray(slugParam)) {
      return slugParam.join("/");
    }
    return slugParam || "";
  });

  const transformItem = (item: any) => {
    const getImage = () => {
      return item.data?.ctpMed?.medFile;
    };

    return {
      title: item.data?.ctpName || item.data?.metaData?.metaTitle || "",
      url: `${URL_CONFIG.NEWS_ROOM_DETAIL}/${item.data?.ctpUrlKey || ""}`,
      altImage:
        item.data?.ctpMed?.medAltText ||
        item.data?.ctpName ||
        item.data?.metaData?.metaTitle ||
        "",
      image: getImage(),
      content: item.data?.ctpContent || "",
      metaTitle: item.data?.metaData?.metaTitle || item.data?.ctpName || "",
      metaDescription: item.data?.metaData?.metaDescription || "",
    };
  };

  const {
    data: newsRoomDetailData,
    error,
    pending,
  } = useAsyncData(
    `newsroom-detail-page-url-${slug.value}`,
    async () => {
      const dataQuery: any = {
        ctpUrlKey: slug.value,
        ctpStatus: "Active",
      };

      const countryCode = (localeStore.locale as any)?.country?.code || "US";
      dataQuery.countryRestrictionsWhitelist = {
        countryCode: { $nin: [`${countryCode}`] },
      };
      dataQuery.whitelistCountryRestrictions = {
        $or: [
          { $size: 0 },
          { $exists: false },
          { countryCode: { $in: [`${countryCode}`] } },
        ],
      };

      const result = await service.fetchManyModels(
        CONTENT_TYPES.NEWSROOM,
        undefined,
        false,
        {
          limit: 1,
          fields: [
            "data.ctpName",
            "data.ctpMed",
            "data.ctpUrlKey",
            "data.metaData",
            "data.ctpContent",
            "data.ctpSubtitle",
            "data.ctpPublishAt",
            "data.ctpStatus",
          ],
          query: { data: dataQuery },
        }
      );

      const transformed = (result || []).map((item: any) =>
        transformItem(item)
      );

      return transformed.length > 0 ? transformed[0] : null;
    },
    {
      server: true,
      lazy: false,
      watch: [slug],
    }
  );

  return {
    data: newsRoomDetailData,
    error,
    pending,
  };
};
